import {eatalianoAxios} from "@/data/api/http/axios";
import {FeaturedProductDetails, FeaturedProductFormValues} from "@/data/entities/product";
import { UpdatedOrdering } from "@/utils/Ordering";

export const listFeaturedProducts = (restaurantId: number): Promise<FeaturedProductDetails[]> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/products/featured`)
        .then(response => response.data)
);

export const deleteFeaturedProduct = (
    restaurantId: number,
    featuredProductId: number,
): Promise<FeaturedProductDetails[]> => (
    eatalianoAxios
        .delete(`/restaurant/${restaurantId}/products/featured/${featuredProductId}`)
        .then(response => response.data)
);

export const updateFeaturedProductsOrdering = (
    restaurantId: number,
    updatedOrdering: UpdatedOrdering[],
): Promise<FeaturedProductDetails[]> => (
    eatalianoAxios
        .put(`/restaurant/${restaurantId}/products/featured/ordering`, updatedOrdering)
        .then(response => response.data)
);

export const getFeaturedProductDetails = (
    restaurantId: number,
    featuredProductId: number,
): Promise<FeaturedProductDetails> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/products/featured/${featuredProductId}`)
        .then(response => response.data)
);

export const createFeaturedProduct = (
    restaurantId: number,
    fields: FeaturedProductFormValues,
): Promise<FeaturedProductDetails> => (
    eatalianoAxios
        .post(`/restaurant/${restaurantId}/products/featured`, fields)
        .then(response => response.data)
);

export const updateFeaturedProduct = (
    restaurantId: number,
    featuredProductId: number,
    fields: FeaturedProductFormValues,
): Promise<FeaturedProductDetails> => (
    eatalianoAxios
        .put(`/restaurant/${restaurantId}/products/featured/${featuredProductId}`, fields)
        .then(response => response.data)
);